import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
export type CreateWorkflowRequestData = {
  key: string;
  name: string;
  project_id: string;
  steps: {
    id: string;
    table_key: string;
    // OG name or override
    name: string;
    version: number;
  }[];
  results: {
    // Concatenation of result key and source table ID—key
    id: string;
    output_policy: "KEEP" | "DISCARD";
    intermediate: boolean;
  }[];
  inputs: {
    id: string;
    intermediate: boolean;
  }[];
  // used for populating workflows from schema later in the absence of tables
  edges: { source: string; target: string }[];
  // For mapping sources into input columns in workflow table
  // backend: ignore for now
  sourceMap: {
    // paramKey is really input ID because param keys are not unique
    [paramKey: string]:
      | {
          tableId: string | undefined;
          columnId: string | undefined;
        }
      | undefined;
  };
};
export const workflowCreate = djangoClientQueryFactory(
  {
    method: "post",
    path: "/wrs/workflow/create_from_tables/",
  },
  {
    formatInput: (input: CreateWorkflowRequestData) => {
      return {
        body: {
          key: input.key,
          name: input.name,
          project: input.project_id,
          edges: input.edges,
          results: input.results,
          steps: input.steps,
          inputs: input.inputs,
        },
      };
    },
    handleResponse: (res) => {
      assert(res.data !== undefined);
      return res.data;
    },
  },
);
